import type Folder from '../store/schema/Folder';

/**
 * Returns if the given folder is distinguished folder or not
 * @param folder
 */
export const isFolderDistinguishedFolder = (folder: Folder): boolean =>
    !!folder.DistinguishedFolderId;
